class WidgetCoordinate {
  constructor(private readonly _x: number = NaN, private readonly _y: number = NaN) {
  }

  public move(x: number, y: number): WidgetCoordinate {
    const nextX: number = this._x + x <= 0 ? 0 : this._x + x;
    const nextY: number = this._y + y <= 0 ? 0 : this._y + y;
    return new WidgetCoordinate(nextX, nextY);
  }

  get x() {
    return this._x;
  }

  get y() {
    return this._y;
  }
}

export default WidgetCoordinate;
